export interface Bank {
	id: string;
	bankName: string;
	paystackCode: string;
	safeHavenCode: string;
}

export interface Wallet {
	id: string;
	userId: string;
	tiedBalance: string;
	withdrawableBalance: string;
	totalDeposit: string;
	totalWithdrawal: string;
	createdAt: string;
	updatedAt: string;
}

export interface BankAccount {
	id: string;
	accountNumber: string;
	accountName: string;
	isPrimary: boolean;
	bankId: string;
	userId: string;
	bank: {
		id: string;
		bankName: string;
		status: string;
		paystackCode: string;
		safeHavenCode: string;
		vfdBankCode: string;
		createdAt: string;
		updatedAt: string;
	};
}

export interface Transaction {
	id: string;
	amount: string;
	type: "DEPOSIT" | "WITHDRAWAL" | "PURCHASE";
	status: "PENDING" | "COMPLETED" | "FAILED";
	createdAt: string;
	updatedAt: string;
}

export enum PaymentProvider {
	PAYSTACK = "paystack",
	SAFEHAVEN = "safe_haven",
	WALLET = "wallet",
	VFD = "vfd_bank"

}

export enum TransactionType {
	WITHDRAW_FUNDS = "WITHDRAW_FUNDS",
	DEPOSIT_FUND = "DEPOSIT_FUND",
	ORDER_SETTLEMENT = "ORDER_SETTLEMENT",
	ORDER_PAYMENT = "ORDER_PAYMENT"
}

export enum TransactionFeeType {
	PURCHASE = "PURCHASE",
	FUNDING = "FUNDING",
	WITHDRAWAL = "WITHDRAWAL"
}
